/**
 * Application scripts
 * Usage: Add imports here for third party scripts, such as GSAP
 *
 * Example: import { gsap } from gsap;
 */
import { gsap } from './app/gsap.min.js';
import { ScrollTrigger } from './app/ScrollTrigger.min.js';
import { ScrollToPlugin } from './app/ScrollToPlugin.min.js';
gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

document.addEventListener('DOMContentLoaded', () => {
	document.querySelectorAll('.card-flip').forEach((card) => {
		const inner = card.querySelector('.card-inner');

		card.addEventListener('mouseenter', () => {
			gsap.to(inner, {
				rotationY: 180,
				duration: 0.6,
				ease: 'power2.inOut',
			});
		});

		card.addEventListener('mouseleave', () => {
			gsap.to(inner, {
				rotationY: 0,
				duration: 0.6,
				ease: 'power2.inOut',
			});
		});
	});
});
